import * as React from 'react';
import { connect } from 'react-redux';
import './CaptureConditions.css';
import { navigateTo } from '../../../actions/navigationActions';
import { CAPTURE_CAR_DETAILS, DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import NeedHelp from '../../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';
import { saveCarCondition } from '../../../actions/selfInspectActions';
import { hideLoadingScreen, showLoadingScreen } from '../../../actions/fullscreenActions';
import { showSubmitSelfInspection } from '../../../actions/modalActions';

class CaptureConditions extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            submitted: false,
            upholsteryDamage: "",
            paintDamage: "",
            hailDamage: "",
            carRebuilt: "",
            concent: false,
            canSubmitDisabled: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.submit = this.submit.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.back = this.back.bind(this);
        this.canSubmitCheck = this.canSubmitCheck.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
        if (this.state.submitted) {
            await this.canSubmitCheck();
        }
    }

    async handleSwitch(e: any) {
        var checked = e.target.checked;
        await this.setState({ concent: checked });
        if (this.state.submitted) {
            await this.canSubmitCheck();
        }
    }

    back() {
        this.props.redirectTo(CAPTURE_CAR_DETAILS);
    }

   async submit(e: any) {
       await  this.setState({ submitted: true })

       if (this.state.upholsteryDamage && this.state.paintDamage && this.state.hailDamage && this.state.carRebuilt && this.state.concent) {
           await this.props.dispatchSaveCarCondition(this.state.upholsteryDamage, this.state.paintDamage, this.state.hailDamage, this.state.carRebuilt)
           await this.props.dispatchShowSubmitSelfInspection()
       }
       else {
           await this.canSubmitCheck();
       }
    }

    async canSubmitCheck() {
        if (this.state.upholsteryDamage && this.state.paintDamage && this.state.hailDamage && this.state.carRebuilt && this.state.concent) {
            this.setState({ canSubmitDisabled: false })
        }
        else {
            this.setState({ canSubmitDisabled: true })
        }
    }

    public render() {
        let productType = "Car";
        let productTypeLower = "car";
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Car" }]
        if (this.props.selfInspect.selectedPersonalCover.product === 7) {
            productType = "Motorbike";
            productTypeLower = "motorbike";
            BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Motorbike" }]
        }
        let submitted = this.state.submitted;
        return (
            <>
                {this.props.selfInspect.selectedPersonalCover && this.props.selfInspect.selectedPersonalCover.riskItems[0] &&
                    <div id="CarCondition" className="container-fluid new-page-margins">
                        <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-conditions-actual">
                            <KPBreadCrumb navList={BreadcrumbDetails} activePage="Self-inspection" />
                        </div>
                        <div className="row new-page-main-row">
                            <div className="new-content-box capture-conditions-container">
                            {/*/// Container Start ///*/}
                            <div className="capture-conditions-header">
                                <h3 className="carName mb-2">{productType} inspection</h3>
                                <p className="Step-Description mb-4">{this.props.selfInspect.selectedPersonalCover.riskItems[0].description}</p>
                            </div>
                            <div className="row capture-details-header-bottom-border"></div>
                            {/*///  SSP Vertical Progress Bar Container ///*/}
                            {/*/// Change row class ssp-vpb-step-done-or-current to ssp-vpb-step-done / ssp-vpb-step-current ///*/}
                            <div className="ssp-vertical-progressbar-container">
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>Snap a photo</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>{productType} details</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step: Current ///*/}
                                <div className="row ssp-vpb-step-current">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <div className="capture-conditions-container-step-content">
                                            {/*/// Add Validation + 'form-has-error' class here to form-container div ///*/}
                                            <div className={"form-container " + (submitted && !this.state.carRebuilt || submitted && !this.state.paintDamage || submitted && !this.state.hailDamage || submitted && !this.state.upholsteryDamage || submitted && !this.state.concent ? ' form-has-error' : '')}>
                                                <>
                                                    <div className="capture-conditions-step-header">
                                                        <h3>Condition of {productTypeLower}</h3>
                                                        <p>Take a look at the statements below and tick yes or no</p>
                                                    </div>
                                                    <hr />
                                                    <div className="capture-conditions-questions-block">
                                                        <div className="text-left">
                                                            <p>My upholstery has existing damage</p>
                                                        </div>
                                                        <div className={'form-group' + (submitted && !this.state.upholsteryDamage ? ' has-error' : '')}>
                                                            <button className={this.state.upholsteryDamage === "yes" ? 'btn btn-outline-secondary questionButton active capture-conditions-questions-yesbutton' : 'btn btn-outline-secondary questionButton capture-conditions-questions-yesbutton'} value="yes" name="upholsteryDamage" onClick={this.handleChange}>Yes</button>
                                                            <button className={this.state.upholsteryDamage === "no" ? 'btn btn-outline-secondary questionButton active' : 'btn btn-outline-secondary questionButton'} value="no" name="upholsteryDamage" onClick={this.handleChange}>No</button>
                                                            {submitted && !this.state.upholsteryDamage &&
                                                                <div className="help-block">Please make a selection</div>
                                                            }
                                                        </div>
                                                        <hr />
                                                        <div className="text-left">
                                                            <p>My {productTypeLower} has paint damage</p>
                                                        </div>
                                                        <div className={'form-group' + (submitted && !this.state.paintDamage ? ' has-error' : '')}>
                                                            <button className={this.state.paintDamage === "yes" ? 'btn btn-outline-secondary questionButton active capture-conditions-questions-yesbutton' : 'btn btn-outline-secondary questionButton capture-conditions-questions-yesbutton'} value="yes" name="paintDamage" onClick={this.handleChange}>Yes</button>
                                                            <button className={this.state.paintDamage === "no" ? 'btn btn-outline-secondary questionButton active' : 'btn btn-outline-secondary questionButton'} value="no" name="paintDamage" onClick={this.handleChange}>No</button>
                                                            {submitted && !this.state.paintDamage &&
                                                                <div className="help-block">Please make a selection</div>
                                                            }
                                                        </div>
                                                        <hr />
                                                        <div className="text-left">
                                                            <p>My {productTypeLower} has hail damage</p>
                                                        </div>
                                                        <div className={'form-group' + (submitted && !this.state.hailDamage ? ' has-error' : '')}>
                                                            <button className={this.state.hailDamage === "yes" ? 'btn btn-outline-secondary questionButton active capture-conditions-questions-yesbutton' : 'btn btn-outline-secondary questionButton capture-conditions-questions-yesbutton'} value="yes" name="hailDamage" onClick={this.handleChange}>Yes</button>
                                                            <button className={this.state.hailDamage === "no" ? 'btn btn-outline-secondary questionButton active' : 'btn btn-outline-secondary questionButton'} value="no" name="hailDamage" onClick={this.handleChange}>No</button>
                                                            {submitted && !this.state.paintDamage &&
                                                                <div className="help-block">Please make a selection</div>
                                                            }
                                                        </div>
                                                        <hr />
                                                        <div className="text-left">
                                                            <p>My {productTypeLower}’s been rebuilt</p>
                                                        </div>
                                                        <div className={'form-group' + (submitted && !this.state.carRebuilt ? ' has-error' : '')}>
                                                            <button className={this.state.carRebuilt === "yes" ? 'btn btn-outline-secondary questionButton active capture-conditions-questions-yesbutton' : 'btn btn-outline-secondary questionButton capture-conditions-questions-yesbutton'} value="yes" name="carRebuilt" onClick={this.handleChange}>Yes</button>
                                                            <button className={this.state.carRebuilt === "no" ? 'btn btn-outline-secondary questionButton active' : 'btn btn-outline-secondary questionButton'} value="no" name="carRebuilt" onClick={this.handleChange}>No</button>
                                                            {submitted && !this.state.carRebuilt &&
                                                                <div className="help-block">Please make a selection</div>
                                                            }
                                                        </div>
                                                        <hr />
                                                    </div>
                                                </>
                                                <h3 className="capture-conditions-accept-h3">Accept and submit self-inspection</h3>
                                                <div className="capture-conditions-tcs-holder">
                                                    <div className="row align-items-center">
                                                        <div className="capture-conditions-switch-col align-self-center">
                                                            <div className="switch">
                                                                <input type="checkbox" id="truthCheck" name="concent" onChange={this.handleSwitch} />
                                                                <label htmlFor="truthCheck"></label>
                                                            </div>
                                                        </div>
                                                        <div className="col align-self-center capture-conditions-label-col">
                                                            <label htmlFor="truthCheck">I hereby declare that all info provided is true and complete</label>
                                                        </div>
                                                        {submitted && !this.state.concent &&
                                                            <div className={'capture-conditions-tcs-error col-12 form-group' + (submitted && !this.state.concent ? ' has-error' : '')}>
                                                                <div className="help-block">Please accept to continue</div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="row justify-content-center capture-conditions-button-holder">
                                                    <div className="col-12 showsubmit-error">
                                                        Please complete all the required fields
                                                    </div>
                                                    <div className="col-12 capture-conditions-button-holder-actual">
                                                        <div className="row justify-content-center">
                                                            <div className="col capture-conditions-buttons-col-back">
                                                                <button className="btn btn-block btn-outline-red " type="button" id="CancelCarData" onClick={this.back}>Back</button>
                                                            </div>
                                                            <div className="capture-conditions-buttons-col-gutter"></div>
                                                            <div className="col capture-conditions-buttons-col-next">
                                                                {/*/// NOTE: Remove real-submit class on next button once real validation is implemented ///*/}
                                                                <button className="btn btn-block btn-solid-red btn-red-disabled-handler" type="button" id="NextCarData" disabled={this.state.canSubmitDisabled} onClick={this.submit}>Submit</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done-or-current">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>Done</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/* /// End Vertical Progress Steps ///*/}
                            </div>
                            {/*/// End SSP Vertical Progress Bar Container ///*/}
                            {/*/// Container End ///*/}
                        </div>
                            {/*/// *** **** ///*/}
                        </div>
                        <div className="row selfinspection-needhelp-row">
                            <div className="col">
                          <NeedHelp
                                isSelfInspect={false}
                                countryId={this.props.profile.countryId}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                />
                            </div>
                        </div>
                    </div>}
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        selfInspect: state.selfInspect,
        ssp:state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSaveCarCondition: (upholsteryDamageAnswer, paintDamageAnswer, hailDamageAnswer, carRebuiltAnswer, engineNr, make, model) => dispatch(saveCarCondition(upholsteryDamageAnswer, paintDamageAnswer, hailDamageAnswer, carRebuiltAnswer)),
        dispatchShowLoadingScreen: () => dispatch(showLoadingScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchShowSubmitSelfInspection: () => dispatch(showSubmitSelfInspection()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureConditions);